import React from 'react'

export default ({title, cost, items, action, onClick, disabled}) => (
  <div className="plan">
    <div className="plan-title">{title}</div>
    <div className="plan-cost">{cost}
    {cost != 'Free' ? 
        <span className="plan-month">/mo</span>
    : ''}
    </div>
    <div className="features">
    {items.map((item) => <div className="feature">{item}</div>)}
    </div>
    <button disabled={disabled} className="blue-button action-button" onClick={onClick}>{action}</button>
  </div>
)
